export const isInvalidStorageValue = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  value === "undefined" ||
  value === "null";

export const readSafeStorage = (key, fallback = "") => {
  try {
    const value = localStorage.getItem(key);
    return isInvalidStorageValue(value) ? fallback : value;
  } catch (error) {
    return fallback;
  }
};

export const writeSafeStorage = (key, value) => {
  try {
    if (isInvalidStorageValue(value)) {
      localStorage.removeItem(key);
      return false;
    }

    const normalizedValue = String(value).trim();
    if (isInvalidStorageValue(normalizedValue)) {
      localStorage.removeItem(key);
      return false;
    }

    localStorage.setItem(key, normalizedValue);
    return true;
  } catch (error) {
    return false;
  }
};

export const removeStorageKey = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};